import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserFromOAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUserFromOAuth(data.user, data.session_token);
        window.history.replaceState({}, "", "/");
        navigate("/");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUserFromOAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="font-serif text-2xl text-olive">Pressing the oil…</p>
    </div>
  );
}
